import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'iea-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.css']
})
export class ChatBotComponent implements OnInit {

  @Input()
  public messages;
  @Output()
  public inputText = new EventEmitter();

  istoggled = false;
  isSpeaking = false;
  constructor() { }

  ngOnInit(): void {
  }

  toggle() {
    this.istoggled = !this.istoggled;
  }

  startSpeaking() {
    this.isSpeaking = true;
  }
  stopSpeaking() {
    this.isSpeaking = false;
  }
  sendActivity(e) {
    this.inputText.emit({ message: e.srcElement.value });
  }
}
